import UserManagement from "../components/admin-panel/user_management/UserManagement";
function User_Management() {
  return <div className="pt-5">{ <UserManagement /> }</div>;
}
export default User_Management;
